export const MAX_WIDTH = 521;
